module.exports = __webpack_public_path__ + "static/media/415GriffinStNW_2018-06-05_41.3679b1aa.jpg";